import * as React from "react";
import { Icon } from "@iconify/react";

export class Profile extends React.Component<
  { avatar?: string },
  { avatarLoaded: boolean }
> {
  public state = {
    avatarLoaded: true,
  };

  public render() {
    const { avatarLoaded } = this.state;
    return (
      <>
        {!avatarLoaded && (
          <Icon
            icon={"healthicons:body"}
            height={480}
            width={342}
            color={"white"}
          />
        )}
        <img
          hidden={!avatarLoaded}
          onError={() =>
            this.setState({ avatarLoaded: false })
          }
          onLoad={() =>
            this.setState({ avatarLoaded: true })
          }
          height={480}
          width={240}
          alt={""}
          style={{
            borderRadius: `60%`,
          }}
          src={this.props.avatar}
        />
      </>
    );
  }
}
